"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcDataAutocompleteField = void 0;
var react_1 = __importStar(require("react"));
var react_autocomplete_1 = __importDefault(require("react-autocomplete"));
var clsx_1 = __importDefault(require("clsx"));
var client_1 = require("@apollo/client");
var util_1 = require("@aperza/util");
var AcDataAutocompleteFieldChip_1 = require("./AcDataAutocompleteFieldChip");
var AcDataAutocompleteField = function (_a) {
    var _b, _c, _d, _e, _f;
    var fieldName = _a.fieldName, label = _a.label, placeholder = _a.placeholder, readOnly = _a.readOnly, invalid = _a.invalid, errorId = _a.errorId, _g = _a.value, value = _g === void 0 ? '' : _g, onBlur = _a.onBlur, onChange = _a.onChange, query = _a.query, _h = _a.queryLimit, queryLimit = _h === void 0 ? 20 : _h, _j = _a.getValueFromDataRow, getValueFromDataRow = _j === void 0 ? function (dr) { return undefined; } : _j, _k = _a.getChipTitleFromDataRow, getChipTitleFromDataRow = _k === void 0 ? function (dr) { return undefined; } : _k, _l = _a.getChipSubtitleFromDataRow, getChipSubtitleFromDataRow = _l === void 0 ? function (dr) { return undefined; } : _l, _m = _a.getItemTitleFromDataRow, getItemTitleFromDataRow = _m === void 0 ? function (dr) { return undefined; } : _m, _o = _a.getQueryVariable, getQueryVariable = _o === void 0 ? function (v) { } : _o, noDataItem = _a.noDataItem, hideNoDataItem = _a.hideNoDataItem, pathToPage = _a.pathToPage, initialSelectedDataRow = _a.initialSelectedDataRow;
    var _p = __read(client_1.useLazyQuery(query), 2), suggestDataRows = _p[0], _q = _p[1], data = _q.data, loading = _q.loading;
    var _r = __read(react_1.useState(initialSelectedDataRow), 2), selectedDataRow = _r[0], setSelectedDataRow = _r[1];
    var inputRef = react_1.useRef(null);
    var _s = __read(react_1.useState(false), 2), showAllSuggestions = _s[0], setShowAllSuggestions = _s[1];
    var refetchQuery = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(value && value !== '')) return [3 /*break*/, 2];
                    if (selectedDataRow && value === getValueFromDataRow(selectedDataRow))
                        return [2 /*return*/];
                    return [4 /*yield*/, suggestDataRows({ variables: __assign(__assign({}, getQueryVariable(value)), { limit: queryLimit }) })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var debouncedRefetchQuery = util_1.DebounceUtil.debounce(refetchQuery, 250, { maxWait: 1000 });
    var onChangeValue = function (val, dataRow) {
        setShowAllSuggestions(false);
        if (onChange)
            onChange(fieldName || 'AcDataAutocompleteField', val, dataRow);
    };
    react_1.useEffect(function () {
        debouncedRefetchQuery();
    }, [value]);
    /**
     * Updated initialSelectedDataRow means the Field is initialized to handle a new domain
     */
    react_1.useEffect(function () {
        if (initialSelectedDataRow) {
            setSelectedDataRow(initialSelectedDataRow);
        }
    }, [initialSelectedDataRow]);
    react_1.useEffect(function () {
        // Only clear value if selectedDataRow is set to null. Cleared by chip.
        // Otherwise, the initial value will be changed to ''
        if (selectedDataRow === null) {
            onChangeValue('', undefined);
        }
    }, [selectedDataRow]);
    var getPageData = function () {
        return util_1.ObjectUtil.get(data, pathToPage);
    };
    var dataRows = react_1.useMemo(function () {
        return getPageData();
    }, [data, pathToPage]);
    var getItems = function () {
        if (loading) {
            return [
                {
                    id: -1,
                    shortcutName: '',
                    faxNumber: '',
                },
            ];
        }
        if (!Array.isArray(dataRows)) {
            return [];
        }
        if ((dataRows === null || dataRows === void 0 ? void 0 : dataRows.length) === 0 && value !== '' && !hideNoDataItem) {
            return noDataItem
                ? [noDataItem]
                : [
                    {
                        id: -1,
                        NODATAAcDataAutocompleteField: '検索結果はありません',
                    },
                ];
        }
        if ((dataRows === null || dataRows === void 0 ? void 0 : dataRows.length) > 10 && !showAllSuggestions) {
            // show option to show more and only show 10
            var firstTen = dataRows === null || dataRows === void 0 ? void 0 : dataRows.slice(0, 10);
            var more = {
                id: -1,
                MOREAcDataAutocompleteField: (react_1.default.createElement("a", { href: "#", onClick: function () {
                        setShowAllSuggestions(true);
                        return false;
                    } }, "\u4ED6 " + ((dataRows === null || dataRows === void 0 ? void 0 : dataRows.length) - 10) + " \u4EF6\u306E\u5019\u88DC")),
            };
            return __spreadArray(__spreadArray([], __read(firstTen)), [more]);
        }
        // else return everything, between 1 and 20 results
        return dataRows;
    };
    var onAutoCompleteChange = function (e) {
        var val = e.target.value;
        onChangeValue(val, undefined);
    };
    var onAutoCompleteBlur = function (e) {
        var val = e.target.value;
        if (onBlur)
            onBlur(fieldName || 'AcDataAutocompleteField', val);
    };
    var onSelect = function (dataRowId) {
        var _dataRow = getItems().find(function (dataRow) {
            var rawDataRowId = getValueFromDataRow(dataRow);
            var stringDataRowId = rawDataRowId !== undefined ? "" + rawDataRowId : '';
            return stringDataRowId === dataRowId;
        });
        // create chip
        onChangeValue(getValueFromDataRow(_dataRow), _dataRow);
        setSelectedDataRow(_dataRow);
    };
    var renderItem = function (dataRow, isHighlighted) {
        var dataRowValue = getValueFromDataRow(dataRow);
        // @ts-ignore
        var isMore = dataRow.MOREAcDataAutocompleteField;
        // @ts-ignore
        var isNoData = dataRow.NODATAAcDataAutocompleteField;
        var chipTitle = isNoData || isMore || getChipTitleFromDataRow(dataRow);
        var chipSubtitle = isMore ? '' : getChipSubtitleFromDataRow(dataRow);
        return (react_1.default.createElement("div", { key: "SuggestDataRow:" + dataRowValue, title: !loading && dataRowValue ? getItemTitleFromDataRow(dataRow) : undefined, className: "d-flex flex-row border " + (isHighlighted ? 'bg-apzlightblue border-line' : 'bg-white border-white') + " px-2 py-1", style: {
                cursor: 'default',
                // @ts-ignore
                // width: inputRef?.current?.offsetWidth - 2,  // keep the dropdown items same width as form field, the -2 takes into account menu padding
            } },
            react_1.default.createElement("div", { className: "text-truncate text-dark fs-14", style: {} }, loading ? (react_1.default.createElement("i", { className: "fas fa-spinner fa-spin fs-12 text-cloudLink", role: "status" })) : (chipTitle)),
            !loading && chipSubtitle && (react_1.default.createElement("div", { className: "fs-11 flex-shrink-0 ml-auto", style: {} }, chipSubtitle))));
    };
    var renderInput = function (propsRI) {
        var inputEl = react_1.default.createElement("input", __assign({ className: "form-control" }, propsRI));
        if (getValueFromDataRow(selectedDataRow)) {
            inputEl = (react_1.default.createElement(AcDataAutocompleteFieldChip_1.AcDataAutocompleteFieldChip, { title: getChipTitleFromDataRow(selectedDataRow), subtitle: getChipSubtitleFromDataRow(selectedDataRow), onClearChip: function () { return setSelectedDataRow(null); } }));
        }
        return (react_1.default.createElement("div", { className: clsx_1.default('form-group', { 'form-validation-error': invalid && errorId }), ref: inputRef },
            label && react_1.default.createElement("label", { className: "form-label" }, label),
            inputEl,
            invalid && errorId && !readOnly && (react_1.default.createElement("div", { className: "invalid-feedback", style: { display: 'block' } }, errorId))));
    };
    return (react_1.default.createElement(react_autocomplete_1.default, { wrapperStyle: { display: 'block' }, items: getItems(), renderItem: renderItem, value: "" + value, getItemValue: function (item) {
            var itemId = getValueFromDataRow(item);
            return itemId !== undefined ? "" + itemId : '';
        }, onSelect: onSelect, onChange: onAutoCompleteChange, renderInput: renderInput, inputProps: {
            placeholder: placeholder,
            onBlur: onAutoCompleteBlur,
        }, isItemSelectable: function (item) { return (item === null || item === void 0 ? void 0 : item.id) > 0; }, 
        // open // remove me, for testing
        menuStyle: {
            boxShadow: '0 0 0 1px lightgrey',
            position: 'absolute',
            top: ((_c = (_b = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _b === void 0 ? void 0 : _b.children[1]) === null || _c === void 0 ? void 0 : _c.offsetTop) +
                ((_e = (_d = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _d === void 0 ? void 0 : _d.children[1]) === null || _e === void 0 ? void 0 : _e.offsetHeight),
            left: (_f = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _f === void 0 ? void 0 : _f.offsetLeft,
            padding: '1px',
            borderRadius: '0px 0px 2px 2px',
            visibility: getItems().length ? 'visible' : 'hidden',
            background: 'white',
            zIndex: 1,
            maxHeight: showAllSuggestions ? '350px' : null,
            overflow: showAllSuggestions ? 'auto' : null,
        } }));
};
exports.AcDataAutocompleteField = AcDataAutocompleteField;
exports.AcDataAutocompleteField.displayName = 'AcDataAutocompleteField';
//# sourceMappingURL=AcDataAutocompleteField.js.map